import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReserveService } from './reserve.service';
import { ReserveListComponent } from './reserve-list.component';

@Component({
    selector: 'app-reserve-delete',
    templateUrl: './reserve-delete.component.html',
    styleUrls: ['./reserve-delete.component.css'],
    standalone: false
})
export class ReserveDeleteComponent {

  uid: number = this.data.uid;
  type: string = this.data.type;
  error_msg: string;
  error: boolean = false;

  constructor(
    public reserveService: ReserveService,
    public dialogRef: MatDialogRef<ReserveListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  delete() {
    this.reserveService.deleteData(this.uid);
    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
